const faqs = [
  {
    q: '正品蓝导航是什么？',
    a: '正品蓝导航是一个专业权威的网址导航平台，汇聚海量正品网站资源，经过严格人工审核，为用户提供安全、可靠的上网入口。我们致力于帮助用户告别假冒仿冒网站，一站直达正品官方网站。',
  },
  {
    q: '如何确保收录网站是正品？',
    a: '我们对每一个收录网站都进行严格的人工审核，包括域名所有权验证、网站资质审核、用户口碑评价和安全扫描检测等多重审核机制。同时，我们也接受用户举报，持续维护网站库的质量。',
  },
  {
    q: '正品蓝导航是否收费？',
    a: '正品蓝导航完全免费使用。我们坚持为用户提供纯净、无广告的上网导航体验。用户无需注册即可使用所有功能。',
  },
  {
    q: '如何申请收录我的网站？',
    a: '您可以通过"关于我们"页面的联系方式与我们取得联系。我们的编辑团队会按照标准流程对您的网站进行审核，审核通过后即可收录到正品蓝导航平台。',
  },
  {
    q: '遇到假冒网站如何举报？',
    a: '如您发现疑似假冒网站，可以通过"关于我们"页面的联系方式或直接在网站上找到反馈入口进行举报。我们会在收到举报后的24小时内进行核实处理。',
  },
];

export default function FAQSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于正品蓝导航，您想了解的都在这
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {faq.q}
                </span>
                <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center">
                  <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform text-lg"></i>
                </div>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}